import { DataGridCellParams } from "@components/common/data-grid/adm-data-grid-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** The column definition for the company's members table with the field property typed */
export type MembersTableGridColDef = DataGridCellParams<
  FaroCoreApiTypes.AdmCompanyMemberWithAuth,
  MembersTableColumnField
>;

/** The column fields that can be used in the company's members table */
export type MembersTableColumnField =
  "name" | "email" | "role" | "status" | "authenticationType" | "options";

/** The labels for the columns in the company's members table */
export const MEMBERS_TABLE_COLUMN_LABELS: Record<
  MembersTableColumnField,
  string
> = {
  name: "Name",
  email: "Email",
  role: "Role",
  status: "Status",
  authenticationType: "Authentication Type",
  options: "",
};
